/**
 * Catalog menu item modifier (priced add-on) or public API shape.
 * Catalog: uuid, sort_order, price_delta, is_active, translations
 * Public menu: uuid, name, price_delta
 */
export default class MenuItemModifier {
  constructor(data = {}) {
    this.uuid = data.uuid ?? ''
    this.sort_order = data.sort_order != null ? Number(data.sort_order) : 0
    this.price_delta = data.price_delta != null ? Number(data.price_delta) : 0
    this.is_active = data.is_active === undefined ? true : !!data.is_active
    this.translations = data.translations && typeof data.translations === 'object' ? { ...data.translations } : {}
    this.name = data.name ?? ''
    /** Restaurant flat payload: parent group (visibility UI). */
    this.modifier_group_uuid = data.modifier_group_uuid ?? ''
    this.modifier_group_name = data.modifier_group_name ?? ''
    this.selection_type = data.selection_type ?? ''
  }

  /** From user/catalog menu item API modifier object. */
  static fromCatalogApi(raw) {
    if (!raw || typeof raw !== 'object') return new MenuItemModifier()
    return new MenuItemModifier({
      uuid: raw.uuid,
      sort_order: raw.sort_order,
      price_delta: raw.price_delta,
      is_active: raw.is_active,
      translations: raw.translations,
      modifier_group_uuid: raw.modifier_group_uuid,
      modifier_group_name: raw.modifier_group_name,
      selection_type: raw.selection_type,
    })
  }

  /** From public restaurant payload: { uuid, name, price_delta }. */
  static fromPublicApi(raw) {
    if (!raw || typeof raw !== 'object') return new MenuItemModifier()
    return new MenuItemModifier({
      uuid: raw.uuid,
      name: raw.name,
      price_delta: raw.price_delta,
    })
  }

  toCatalogPayload() {
    const out = {
      sort_order: this.sort_order,
      price_delta: this.price_delta,
      is_active: this.is_active,
      translations: this.translations,
    }
    if (this.uuid) out.uuid = this.uuid
    return out
  }
}

/** Stable sorted list of modifier UUIDs for cart line identity. */
export function normalizeModifierUuidList(uuids) {
  if (!Array.isArray(uuids) || !uuids.length) return []
  return [...uuids].map((u) => String(u).trim()).filter(Boolean).sort()
}
